// Dependencies
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get IN_APP_PROMOTION_DEVELOPMENT_FEATURES () {
        return IN_APP_PROMOTION_DEVELOPMENT_FEATURES;
    },
    get IN_APP_PROMOTION_TYPES () {
        return IN_APP_PROMOTION_TYPES;
    },
    get InAppPromotionDevelopmentOptionsModel () {
        return InAppPromotionDevelopmentOptionsModel;
    },
    get InAppPromotionModel () {
        return InAppPromotionModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const IN_APP_PROMOTION_TYPES = {
    meetings: "meetings",
    surveys: "surveys",
    engagement: "engagement",
    premium: "premium",
    enterprise: "enterprise",
    announcement: "announcement",
    ai: "ai",
    development: "development"
};
const IN_APP_PROMOTION_DEVELOPMENT_FEATURES = [
    "compensation",
    "competencies",
    "coaching"
];
const InAppPromotionDevelopmentOptionsModel = _zod.z.object({
    compensation: _zod.z.boolean().nullish(),
    competencies: _zod.z.boolean().nullish(),
    coaching: _zod.z.boolean().nullish()
});
const InAppPromotionModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    description: _zod.z.string(),
    type: _zod.z.string(),
    bannerCopy: _zod.z.string(),
    hyperlink: _zod.z.string(),
    bannerEnabled: _zod.z.boolean().nullish(),
    features: _zod.z.array(_zod.z.string()).nullish(),
    companiesWithModule: _zod.z.boolean().nullish(),
    __v: _zod.z.number()
});
